<template>
  <div class="page-container">
    <div class="query-title">待开票销售订单明细查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="拆分" @click="handleItem('SPLIT')" />
            <table-button name="export" tip="复制" @click="handleCopy" />
            <table-button name="confirm" tip="确定" @click="confirmChecke" />
            <table-button name="delete" tip="删除" @click="handleItem('DELETE')" />
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :show-overflow="true"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :cell-class-name="cellClassName"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #if_offset="{row}">
              <el-checkbox :value="row.if_offset === 'X'" disabled />
            </template>
            <template #use_quantity="{row}">
              <el-input v-model="row.use_quantity" size="mini" @input="inputChange($event, row, 'use_quantity')" />
            </template>
            <template #use_bot="{row}">
              <el-input v-model="row.use_bot" size="mini" @input="inputChange($event, row, 'use_bot')" />
            </template>
            <template #use_zzfld9="{row}">
              <el-input v-model="row.use_zzfld9" size="mini" @input="inputChange($event, row, 'use_zzfld9')" />
            </template>
            <template #warehouse="{row}">
              <el-select v-model="row.warehouse" size="mini">
                <el-option
                  v-for="item in selectDataOptions['A0039']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

    <el-dialog
      title="复制拆分"
      :visible.sync="copyDialogVisible"
      width="500px"
      @closed="resetCopyDialog"
    >
      <el-form
        ref="copyForm"
        :model="copyForm"
        :rules="copyFormRules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="复制行数" prop="rowCount">
          <el-input-number
            v-model="copyForm.rowCount"
            :min="1"
            :max="500"
            :step="1"
            :precision="0"
            placeholder="请输入复制行数"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="每行件数" prop="quantityPerRow">
          <el-input-number
            v-model="copyForm.quantityPerRow"
            :min="1"
            :step="1"
            :precision="0"
            placeholder="请输入每行件数"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="mini" @click="copyDialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="confirmCopy">确定</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiNoMakeInvoiceList, apiSplitOrDelete, apiConfirmItems } from '@/api/sap/make-invoice-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig from '../config/CheckeOrder'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  props: {
    infType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      selectDataOptions: {},
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 }
        ],
        data: []
      },
      searchField: {},
      isSetFilter: false,
      copyDialogVisible: false,
      copyForm: {
        rowCount: null,
        quantityPerRow: null
      },
      copyFormRules: {
        rowCount: [
          { required: true, message: '请输入复制行数', trigger: 'blur' },
          { type: 'number', min: 1, max: 500, message: '复制行数必须在1-500之间', trigger: 'blur' }
        ],
        quantityPerRow: [
          { required: true, message: '请输入每行件数', trigger: 'blur' },
          { type: 'number', min: 1, message: '每行件数必须大于0', trigger: 'blur' }
        ]
      },
      selectedRowForCopy: null
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0039')
    this.initPage(pageConfig)
  },
  methods: {
    cellClassName({ column }) {
      if (column.params?.bgEdit) {
        return 'cell--bg--edit'
      } else {
        return 'cell--bg--default'
      }
    },
    inputChange(e, row, field) {
      if (field === 'use_bot') {
        if ((row.zzfld00002w - 0) !== 0) {
          // row.use_zzfld9 = (e / (row.zzfld00002w - 0)).toFixed(2)
          row.use_quantity = (e - 0) + ((row.use_zzfld9* (row.zzfld00002w - 0)) - 0 )
        }
      } else {
        if ((row.zzfld00002w - 0) !== 0) {
          row.use_quantity = ((e * (row.zzfld00002w - 0)).toFixed(2)-0) + (row.use_bot-0)
        }
      }
      row.use_value = ((field === 'use_quantity' ? e : row.use_quantity) * row.net_price).toFixed(2)
      row.use_zzfld2i = ((row.net_price - row.zzfld00002g) * (field === 'use_quantity' ? e : row.use_quantity)).toFixed(2)
    },
    async handleItem(mode) {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (!checkData) return

      const params = {
        mode,
        inf_type: this.infType,
        data: checkData
      }

      const { msgtype, message } = await apiSplitOrDelete(params)
      if (msgtype === 'S') {
        if (mode === 'SPLIT') {
          // 可以拆分
          this.splitRow(checkData)
        } else {
          // 可以删除
          this.removeData(checkData)
        }
      } else {
        this.$message.warning(message)
      }
    },
    removeData(checkedList) {
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (!data) return

      if (this.dialogTitle === '客户选择') {
        this.conditions.rt_customer = data.customerCode
      } else if (this.dialogTitle === '人员选择') {
        this.conditions.rt_zzfld000004TextView = data.name
        this.conditions.rt_zzfld000004 = data.code
      } else if (this.dialogTitle === '产品选择') {
        this.conditions.rt_product_id = data.productCode
      }
      this.showDialog = false
    },
    splitRow(datas) {
      datas.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        const split_data = { ...item }
        delete split_data._X_ID
        split_data.if_offset = 'X'
        this.gridOptions.data.splice(index + 1, 0, split_data)
      })
    },
    async confirmChecke() {
      // apiConfirmItems inf_type,item
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (!checkData) return

      try {
        // 排除批条酒不验证小数
        if (this.infType !== 'ZB04') {
          // 验证件数是否为整数
          checkData.forEach(item => {
           if (this.infType === 'ZB03' && item.zzfld00002j === 'V015') {
           } else {
             if (!Number.isInteger(Number(item.use_zzfld9))) {
               throw new Error(`订单号：${item.object_id} 开票件数不能为小数！`)
             }
           }
          })
        }
      } catch (e) {
        this.$message.error(e.message)
        return
      }

      const params = {
        inf_type: this.infType,
        item: checkData
      }

      const { msgtype, message, data, number } = await apiConfirmItems(params)
      if (msgtype === 'S') {
        console.log(data)
        if (+number > 1) {
          // 如果返回的行项目大于1条，跳转工作台并展示
          this.$emit('changeActive', 'create', '', data)
        } else {
          // 直接跳转至对应的详情
          this.$emit('changeActive', 'entry', '', null, data[0])
        }
      } else {
        this.$message.warning(message)
      }
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        // 保存 查询组件的查询参数
        this.ranges = ranges
        this.handleRanges(ranges)
        this.isSetFilter = false
      }
      const params = {
        partner: this.$store.getters.role.USER_BP,
        roles: this.$store.getters.role.ROLE,
        inf_type: this.infType,
        zzfld00002j: this.zzfld00002j,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiNoMakeInvoiceList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        data.forEach(item => {
          item.warehouse = 'V012'
        })
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    async exportExcel() {
      const params = {
        inf_type: this.infType,
        partner: this.$store.getters.role.USER_BP,
        ...this.ranges
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiNoMakeInvoiceList)
      frontExport(this.gridOptions.columns, data, '待开票销售订单明细')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    handleCopy() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (!checkData || checkData.length === 0) {
        this.$message.warning('请选择要复制的订单')
        return
      }
      if (checkData.length > 1) {
        this.$message.warning('只能选择一个订单进行复制')
        return
      }
      this.selectedRowForCopy = checkData[0]
      this.copyForm.rowCount = null
      this.copyForm.quantityPerRow = null
      this.copyDialogVisible = true
    },
    resetCopyDialog() {
      this.copyForm = {
        rowCount: null,
        quantityPerRow: null
      }
      this.selectedRowForCopy = null
      if (this.$refs.copyForm) {
        this.$refs.copyForm.clearValidate()
      }
    },
    confirmCopy() {
      this.$refs.copyForm.validate((valid) => {
        if (!valid) return
        
        if (!this.selectedRowForCopy) {
          this.$message.warning('请选择要复制的订单')
          return
        }

        const originalRow = this.selectedRowForCopy
        const rowCount = this.copyForm.rowCount
        const quantityPerRow = this.copyForm.quantityPerRow

        // 找到原数据行在数组中的索引
        const originalIndex = this.gridOptions.data.findIndex(v => v._X_ID === originalRow._X_ID)
        if (originalIndex === -1) {
          this.$message.error('未找到原数据行')
          return
        }

        // 创建拆分后的行数据
        const newRows = []
        for (let i = 0; i < rowCount; i++) {
          const newRow = { ...originalRow }
          // 删除内部ID，让vxe-table自动生成新的ID
          delete newRow._X_ID
          // 设置拆分标识
          newRow.if_offset = 'X'
          newRow.is_split = 'X'
          // 设置每行的件数
          newRow.use_zzfld9 = quantityPerRow
          
          // 根据件数计算其他数量字段
          if (originalRow.zzfld00002w && (originalRow.zzfld00002w - 0) !== 0) {
            // 零头设为0，或者按原比例分配（这里简化处理，设为0）
            newRow.use_bot = 0
            // 计算总数量：瓶数 + (件数 * 每件瓶数)
            newRow.use_quantity = ((quantityPerRow * (originalRow.zzfld00002w - 0)) + newRow.use_bot).toFixed(2) - 0
          } else {
            newRow.use_bot = 0
            newRow.use_quantity = quantityPerRow
          }
          
          // 更新订单数量和订单件数
          newRow.quantity = newRow.use_quantity
          newRow.zzfld000009 = quantityPerRow
          
          // 计算金额相关字段
          if (originalRow.net_price) {
            newRow.use_value = ((newRow.use_quantity * originalRow.net_price)).toFixed(2)
            if (originalRow.zzfld00002g) {
              newRow.use_zzfld2i = ((originalRow.net_price - originalRow.zzfld00002g) * newRow.use_quantity).toFixed(2)
            }
          }

          newRows.push(newRow)
        }

        // 删除原数据行
        this.gridOptions.data.splice(originalIndex, 1)
        
        // 在原位置插入新的拆分行
        this.gridOptions.data.splice(originalIndex, 0, ...newRows)

        this.copyDialogVisible = false
        this.$message.success(`已成功拆分为 ${rowCount} 行`)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container{
  padding: 0 !important;
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/invoice-manage/components/CheckeOrder.vue